import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Map from '@/components/Map'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Map',
      component: Map
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js